import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Charter } from 'anchor-shared/lib/model/entity/charter';
import { StripePaymentDAO } from '../../../../../core/services/dao/stripePaymentDAO';
import { CharterPaymentDAO } from '../../../../../core/services/dao/charterPaymentDAO';
import { PaymentIntent } from '@stripe/stripe-js/types/api/payment-intents';
import { PaymentMethod } from '@stripe/stripe-js';
import { Observable } from 'rxjs/internal/Observable';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-charge-additional-costs-dialog',
  templateUrl: './charge-additional-costs-dialog.component.html',
  styleUrls: ['./charge-additional-costs-dialog.component.scss'],
})
export class ChargeAdditionalCostsDialogComponent implements OnInit {
  paymentReady: boolean;
  paymentIntent: PaymentIntent;
  paymentMethods: PaymentMethod[];
  charter: Charter;
  hoursTotal: number;
  fuelTotal: number;
  costsTotal: number;
  depositTotal: number;

  constructor(
    private dialogRef: MatDialogRef<ChargeAdditionalCostsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      charter: Charter;
      hoursTotal: number;
      fuelTotal: number;
      costsTotal: number;
      depositTotal: number;
    },
    private stripePaymentDAO: StripePaymentDAO,
    private charterPaymentDAO: CharterPaymentDAO,
  ) {}

  ngOnInit(): void {
    this.charter = this.data.charter;
    this.hoursTotal = this.data.hoursTotal;
    this.fuelTotal = this.data.fuelTotal;
    this.costsTotal = this.data.costsTotal;
    this.depositTotal = this.data.depositTotal;
  }

  addAllCosts(): number {
    return (
      this.hoursTotal + this.fuelTotal + this.costsTotal - this.depositTotal
    );
  }

  closeDialog(paymentIntent: PaymentIntent) {
    this.dialogRef.close(paymentIntent);
  }

  chargeAdditionalCosts() {
    const createPaymentIntent = this.charterPaymentDAO.createAdminPaymentIntent(
      this.charter.id,
      this.charter.userId,
      this.addAllCosts().toString(),
      `Charter ${this.charter.id} additional costs`,
      `Fuel cost: $${this.fuelTotal}. Additional hours: $${this.hoursTotal}. Additional costs: $${this.costsTotal}`,
    );

    const obs: Observable<any>[] = [
      createPaymentIntent,
      this.listCustomerPaymentMethods(),
    ];

    const paymentIntentSub = combineLatest(obs).subscribe(
      ([paymentIntent$, paymentMethods$]) => {
        this.paymentReady = true;
        this.paymentIntent = paymentIntent$;
        this.paymentMethods = paymentMethods$.data;
      },
    );
  }

  listCustomerPaymentMethods(): Observable<PaymentMethodData> {
    return this.stripePaymentDAO.adminListCustomerPaymentMethods(
      this.charter.userId,
    );
  }
}
